import { Component } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { LicenceService } from 'src/app/services/utils/licence.service';

@Component({
  selector: 'app-inner-loader',
  templateUrl: './loader-inner.component.html',
  styleUrls: ['./loader-inner.component.scss']
})
export class LoaderInnerComponent extends BaseComponent {
  constructor(
    protected licenceService: LicenceService,
    ){
    super();
  }
 }
